module.exports = __webpack_public_path__ + "static/img/Joel-Cochran.1bddc5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Joel-Cochran.jpg
// module id = Wj4X
// module chunks = 0